import { useMediaQuery } from '@mui/material'
import classNames from 'classnames'
import React from 'react'

const QuestionHeading = ({ heading, subheading = '', wrapClassName = '' }) => {
  const isMobileView = useMediaQuery('(max-width: 767px)')
  const isDesktopView = !isMobileView

  return (
    <div className={`[ f-p-h-020 ] ${wrapClassName}`}>
      {heading && (
        <div
          data-sel='txt-hl'
          className={classNames(
            '[ f-t-tmedium f-p-t-040 ]',
            isDesktopView && 'f-t-centre'
          )}>
          {heading}
        </div>
      )}
      {subheading && (
        <div
          className={classNames(
            '[ f-t-body f-c-fo-pri f-m-t-020 ]',
            isMobileView ? 'f-t-left' : 'f-t-centre'
          )}
          dangerouslySetInnerHTML={{ __html: subheading }}
        />
      )}
    </div>
  )
}

export default QuestionHeading
